import { colors } from "styles/colors";

type Props = {
  className?: string;
};

export const AlcoholIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.666 11.6667H16.9993V14.8667C16.9993 16.045 16.0442 17.0001 14.866 17.0001H13.7994C12.6211 17.0001 11.666 16.045 11.666 14.8667V11.6667Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.98936 4.26274C2.66089 3.76262 1.69039 2.50417 1.57862 1H8.95262C8.84089 2.5036 7.87108 3.76167 6.54338 4.26217C8.27611 5.9254 9.53333 10.8845 9.53333 16.7436C9.53333 16.8293 9.53306 16.9148 9.53253 17H1.0008C1.00027 16.9148 1 16.8293 1 16.7436C1 10.8852 2.25694 5.92653 3.98936 4.26274Z"
        fill="white"
      />
      <path
        d="M1.57862 1V0.466667C1.4303 0.466667 1.28868 0.528427 1.18777 0.637119C1.08686 0.74581 1.03576 0.891615 1.04675 1.03952L1.57862 1ZM3.98936 4.26274L4.35879 4.64741C4.49087 4.52056 4.54863 4.33482 4.51179 4.15544C4.47495 3.97606 4.34865 3.82812 4.17727 3.7636L3.98936 4.26274ZM8.95262 1L9.48448 1.03952C9.49548 0.891615 9.44438 0.74581 9.34346 0.637119C9.24255 0.528427 9.10093 0.466667 8.95262 0.466667V1ZM6.54338 4.26217L6.35525 3.76312C6.18391 3.82771 6.05769 3.97568 6.02091 4.15505C5.98414 4.33443 6.04195 4.52013 6.17405 4.64693L6.54338 4.26217ZM9.53253 17V17.5334C9.82578 17.5334 10.064 17.2966 10.0659 17.0034L9.53253 17ZM1.0008 17L0.467482 17.0034C0.469322 17.2966 0.707559 17.5334 1.0008 17.5334V17ZM1.04675 1.03952C1.17389 2.75053 2.27836 4.18849 3.80146 4.76187L4.17727 3.7636C3.04341 3.33675 2.20689 2.25782 2.11048 0.960477L1.04675 1.03952ZM8.95262 0.466667H1.57862V1.53333H8.95262V0.466667ZM6.7315 4.76122C8.2537 4.1874 9.35739 2.74988 9.48448 1.03952L8.42075 0.960477C8.32438 2.25733 7.48846 3.33594 6.35525 3.76312L6.7315 4.76122ZM10.0667 16.7436C10.0667 13.7787 9.74885 11.0311 9.20632 8.80324C8.67037 6.60242 7.8941 4.81944 6.9127 3.87741L6.17405 4.64693C6.92538 5.36813 7.6441 6.89632 8.16994 9.05563C8.68921 11.1879 9 13.8494 9 16.7436H10.0667ZM10.0659 17.0034C10.0664 16.917 10.0667 16.8304 10.0667 16.7436H9C9 16.8282 8.99973 16.9125 8.99921 16.9967L10.0659 17.0034ZM1.0008 17.5334H9.53253V16.4667H1.0008V17.5334ZM0.466667 16.7436C0.466667 16.8304 0.466939 16.917 0.467482 17.0034L1.53413 16.9967C1.5336 16.9125 1.53333 16.8281 1.53333 16.7436H0.466667ZM3.61994 3.87807C2.63877 4.82036 1.86267 6.6033 1.32683 8.80401C0.784416 11.0317 0.466667 13.7791 0.466667 16.7436H1.53333C1.53333 13.8497 1.84405 11.1885 2.36322 9.05635C2.88895 6.89719 3.60753 5.36891 4.35879 4.64741L3.61994 3.87807Z"
        fill={colors.gray900}
      />
      <path
        d="M15.4012 10.0667C15.6674 9.79998 15.914 9.37904 15.9336 8.99998C15.9336 8.19998 14.8139 7.93332 14.8689 6.86665C14.8884 6.4876 15.1351 6.06665 15.4012 5.79998"
        stroke={colors.pink500}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2684 10.0667C13.5346 9.79998 13.7812 9.37904 13.8008 8.99998C13.8008 8.19998 12.6811 7.93332 12.7361 6.86665C12.7556 6.4876 13.0023 6.06665 13.2684 5.79998"
        stroke={colors.pink500}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
